@let breadcrumbs = breadcrumbs$ | async;
@if (breadcrumbs) {
  @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
    @if (!maxSegments || (breadcrumbs.length - i <= maxSegments)) {
      <a
        style="min-width: 0; padding: 0"
        mat-button
        [routerLink]="breadcrumb.routerLink">
        @if (breadcrumb.label$) {
          {{breadcrumb.label$ | async | truncateWithEllipses:maxLabelSegmentLength }}
        } @else if (breadcrumb.labelSignal) {
          {{ breadcrumb.labelSignal() | truncateWithEllipses:maxLabelSegmentLength }}
        } @else {
          {{breadcrumb.label | truncateWithEllipses:maxLabelSegmentLength }}
        }
        @if (i < breadcrumbs.length - 1) {
          <ng-container><!-- Wrap mat-icon to prevent it from being rendered before the text -->
            <mat-icon style="vertical-align: middle">chevron_right</mat-icon>
          </ng-container>
        }
      </a>
    }
  }
}
